import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

import Button from "@/components/Button";
import SvgIcon from "@/lib/icons/SvgIcon";

const DeletePopup = ({
  isOpen,
  onClose,
  onConfirm,
  isDisabled,
  isLoading,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  confirmLabel = "Delete",
  layout,
}) => (
  <div>
    {isOpen && (
      <div
        className={clsx(
          "fixed top-0 left-0 w-full h-full z-20",
          layout === "full" ? "" : "lg:pl-[var(--sidebar-width,250px)] lg:pt-[87px]"
        )}
      >
        <div className="relative p-8 h-full z-10 flex items-center justify-center">
          <div
            className="bg-black/50 w-full h-full absolute top-0 left-0 -z-10"
            onClick={onClose}
          ></div>
          <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-4 sm:p-6">
            {/* Popup Header */}
            <div className="flex justify-end">
              <Button
                size="md"
                onClick={onClose}
                icon={<SvgIcon name="close" size="1em" />}
              />
            </div>
            <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-2 text-center">
              {title}
            </h2>

            {/* Popup Body */}
            <p className="text-gray-600 mb-6 text-center text-sm sm:text-base">{message}</p>

            {/* Actions */}
            <div className="flex justify-center space-x-4">
              <Button variant="outline" label="Cancel" onClick={onClose} />
              <Button
                variant="solid"
                label={confirmLabel}
                isLoading={isLoading}
                disabled={isDisabled}
                onClick={onConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

DeletePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  isDisabled: PropTypes.string,
  isLoading: PropTypes.string,
  layout: PropTypes.string,
};

export default DeletePopup;
